export const NETWORK_TAB_KEYS = {
  URL_ANALYSIS: "url_analysis",
  DOMAIN_ANALYSIS: "domain_analysis",
  IP_ANALYSIS: "ip_analysis"
} as const;

export const NETWORK_URLS = Object.freeze({
  NETWORK_DETAILS_CLOUD_DYNAMIC: (url: string, hash: string, section: string) =>
    `/url/${encodeURIComponent(url)}/${hash}/dynamic/${section}/`
});

export const NETWORK_ROUTES = [
  { path: "/url/:id/*", name: "url" },
  { path: "/domain/:id/*", name: "domain" },
  { path: "/ip/:id/*", name: "ip" }
];

export const DEFAULT_PAGE_SELECTIONS = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "50", value: "50" }
];

export const USEQUERY_DISABLE_REFETCH_OPTIONS = {
  refetchOnMount: false,
  refetchOnWindowFocus: false
};

export const COMPONENTS_IDS = {
  THIRD_PARTY_REPUTATION_ID: "third-party-reputation",
  THIRD_PARTY_REPUTATION_CARD_ID: "third-party-reputation-card",
  TOP_THREATS_ID: "top-threats",
  DOWNLOADED_FILES_ID: "downloaded-files",
  RELATED_URLS_ID: "related-urls",
  RESOLUTIONS_ID: "resolutions",
  GEOIP_ID: "geo-ip",
  WHOIS_IP_ID: "whois-ip",
  IP_URLS_ID: "ip-urls",
  ANALYSIS_HISTORY_ID: "analysis-history",
  DNS_RECORDS_ID: "dns-records",
  RELATED_DOMAINS_ID: "related-domains",
  REDIRECT_JOURNEY_ID: "redirect-journey",
  DYNAMIC_ANALYSIS_CARD_ID: "dynamic-analysis-card",
  CERTIFICATES_ID: "certificates"
};

export const PREVIEW_DATA_KEYS = {
  SCREENSHOT: "screenshot_url",
  DOM: "dom_url"
};

export const URL_PREVIEW_DATA_ITEMS = [
  PREVIEW_DATA_KEYS.DOM,
  PREVIEW_DATA_KEYS.SCREENSHOT
] as const;

export const URL_EXTENDED_ANALYSIS_WAIT_TIME = 35 * 1000;

export const VALID_URL_PROTOCOL_REGEX = "^https?://.+";

export const MAX_URL_LENGTH = 10000;

export const NETWORK_TABS = {
  DETECTIONS: {
    key: "detections",
    title: "Detections"
  },
  CONTENT: {
    key: "content",
    title: "Content"
  },
  RESOURCES: {
    key: "resources",
    title: "Resources"
  },
  INFRASTRUCTURE: {
    key: "infrastructure",
    title: "Infrastructure"
  },
  RELATIONS: {
    key: "relations",
    title: "Relations"
  },
  DYNAMIC_ANALYSIS: {
    key: "dynamic-analysis",
    title: "Dynamic Analysis"
  },
  ATTRIBUTION: {
    key: "attribution-data",
    title: "Attribution Data"
  },
  MALWARE_FAMILY_INSIGHTS: {
    key: "malware-family-insights",
    title: "Malware Family Insights"
  }
} as const;
